import React from 'react';
import { filledChipStyle, mondayHex, normalizeMondayWord, MondayColumn } from '../../theme/mondayPalette';
import './filledStatusChip.css';

export interface FilledStatusChipProps {
  word: string | null;
  /** Explicit colour wins over the column lookup. */
  hex?: string | null;
  /** Looked up by word when hex is not given. */
  column?: MondayColumn;
  /** Visible text; defaults to the word. */
  label?: React.ReactNode;
  /** Rendered inside the chip after the label. */
  suffix?: React.ReactNode;
  /** 'claim' keeps the fill and adds a dashed outline so a claim is visibly distinct. */
  variant?: 'solid' | 'claim';
  title?: string;
  /** Appended in a visually-hidden span. */
  srText?: string;
  size?: 'sm' | 'md';
  className?: string;
  emptyText?: string;
}

export function FilledStatusChip({
  word,
  hex,
  column,
  label,
  suffix,
  variant = 'solid',
  title,
  srText,
  size = 'md',
  className,
  emptyText = 'No status',
}: FilledStatusChipProps) {
  const normalized = normalizeMondayWord(word);
  if (!normalized) {
    return <span className="fsc fsc--none">{emptyText}</span>;
  }
  const text = label !== undefined && label !== null ? label : word;
  const colour = hex || (column ? mondayHex(column, word) : null);
  if (!colour) {
    return (
      <span className="fsc fsc--unmapped" title="No Monday colour is recorded for this word.">
        {text}
      </span>
    );
  }
  const classes = ['fsc', 'fsc--filled', size === 'sm' ? 'fsc--sm' : '', variant === 'claim' ? 'fsc--claim' : '', className || '']
    .filter(Boolean)
    .join(' ');
  return (
    <span className={classes} style={filledChipStyle(colour)} data-word={normalized} data-hex={colour} title={title}>
      {text}
      {suffix}
      {srText && <span className="fsc-sr">{srText}</span>}
    </span>
  );
}

export default FilledStatusChip;
